import * as d3 from 'd3';
import * as toastr from 'toastr';

import { IChartOptions } from '../../models/IChartOptions';
import { SvgManager } from '../SvgManager';
import { TimeChartBase } from './TimeChartBase';
import { StackedAreaSeries } from '../pieces/series/index';

export class StackedAreaChart extends TimeChartBase {
    private _stack = d3.layout.stack()
        .values((d: any) => { return d.values; });
    private _seriesConfiguration: StackedAreaConfiguration[];

    constructor(options: IChartOptions, svgManager: SvgManager) {
        super(options, svgManager, 'stacked-area-chart');
        this._seriesConfiguration = [];

    }

    updateSeries(newSeriesList: StackedAreaConfiguration[]) {
        try {
            this.clearSeries();
            this._seriesConfiguration = newSeriesList;
            newSeriesList.forEach(c => {
                this.addStackedAreaSeries(c);
            });
        } catch (e) {
            console.error(e);
        }
    }

    addStackedAreaSeries(configuration: StackedAreaConfiguration) {
        const series = new StackedAreaSeries(this.seriesGroup(),
            configuration.name,
            configuration.color,
            d => d.y0,
            d => d.y0 + d.y,
            configuration.identifier,
            d => d.id);
        series.transparency(0.5);
        series.valueFormatter(configuration.valueFormat);
    }

    update(data) {
        try {
            this._seriesConfiguration.reverse();
            const layers = this.layer(data);
            const stacked: any[] = this._stack(layers);
            const arranged = this.flatten(stacked);
            super.update(arranged);
        } catch (e) {
            console.error(e);
            toastr.error(e);
        }
    }

    private layer(data: any[]): any[] {
        const layers = this._seriesConfiguration.map(s => {
            return {
                id: s.identifier,
                values: data
                    .filter(d => s.selector(d) === s.identifier)
                    .map((d: any) => {
                        return {
                            timeStamp: d.timeStamp,
                            y: parseFloat(s.value(d))
                        };
                    })
            };
        });
        return layers;
    }

    private flatten(data: any[]): any[] {
        const arranged = [];
        data.forEach(s => {
            s.values.forEach(v => {
                arranged.push({
                    id: s.id,
                    y0: v.y0,
                    y: v.y,
                    timeStamp: v.timeStamp
                });

            });
        });
        return arranged;

    }
}

export class StackedAreaConfiguration {
    constructor(name: string, color: string, identifier: any, selector: (d: any, i?: any) => any, value: (d, i?) => any) {
        this.name = name;
        this.color = color;
        this.identifier = identifier;
        this.selector = selector;
        this.value = value;
    }

    name: string;
    color: string;
    identifier: any;
    selector: (d, i?) => any;
    value: (d, i?) => any;
    valueFormat = '.2f';
}
